export default "__VITE_ASSET__B0$9JMUW__"